import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqs: FAQItem[] = [
    { question: 'How accurate is the simulation?', answer: 'Our simulations achieve 80–85% directional accuracy based on real market data, verified acquisition costs, and local salary benchmarks. We model three scenarios — conservative, base, and optimistic — so you understand the realistic range of outcomes, not just a single number.' },
    { question: 'How is the data collected?', answer: 'We source actual data from salary databases, competitive intelligence platforms, and verified acquisition cost data from companies already operating in your target market and industry. Every number has a traceable source.' },
    { question: 'What exactly will I receive?', answer: 'You receive a complete 12-month simulation for your target market covering projected revenue, true costs, competition, and break-even timeline — all followed month by month from zero to month twelve. You also receive a multi-market comparison showing how your target market stacks up against others.' },
    { question: 'How long does it take to receive my simulation?', answer: 'Your simulation is delivered within 72 hours of submitting your details. If your market requires additional data we will let you know.' },
    { question: 'Is my business information kept confidential?', answer: 'Yes, completely. Everything you share with us stays strictly between you and us. We never share your information, business details, or expansion plans with any third party under any circumstances. We are fully GDPR compliant.' },
    { question: 'Will you share or use my company information for anything else?', answer: 'No. The information you provide is used solely to build your simulation. It is never sold, shared, or used for any other purpose. Your expansion plans remain entirely confidential.' },
    { question: 'Do I need to sign up or speak to a sales person?', answer: 'No. There is no signup wall and no sales call. You submit your details and receive your simulation within 72 hours. That is it.' },
    { question: 'Can I request simulations for multiple markets?', answer: 'Yes. Additional simulations are always free. You can request as many as you need — for different markets, different scenarios, or different company structures.' },
    { question: 'In what format is the simulation delivered?', answer: 'Your simulation is delivered as a comprehensive PDF report with month-by-month projections, charts, and full cost breakdowns. Excel exports are available on request.' },
    { question: 'Can I share the simulation with my team or investors?', answer: 'Yes. You have full rights to use the simulation internally — with your team, board, or investors. External publication or redistribution requires prior approval from us.' }
  ];

  return (
    <div className="section">
      <div className="section-label"><span>Questions</span></div>
      <h2 className="section-title">Questions we get<br /><em>before the simulation.</em></h2>
      <p className="section-sub">Everything you need to know about how it works, what you receive, and what happens after you submit.</p>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
            onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
          >
            <div className="faq-q">
              <span>{faq.question}</span>
              <span className="toggle">+</span>
            </div>
            <div className="faq-a">{faq.answer}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
